/**
 * 公共素材库
 * author: liu.linhai
 */
'use strict';
angular.module('manageSysManagePublicMaterialLibraryModule', [
        'publicLibraryCategoryServiceModule',
        'manageSysManagePublicMaterialLibraryRouterModule',
        'manageSysManageCategoryLibraryManageModule'
    ])
    .controller('manageSysManagePublicMaterialLibraryCtrl', ['$scope', 'trsHttpService', '$q', 'publicLibraryCategoryService', 'modalDialog', '$state', 'trsspliceString', function($scope, trsHttpService, $q, publicLibraryCategoryService, modalDialog, $state, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
                "copyCurrPage": 1,
            };

            $scope.status = {

            };

            $scope.data = {
                items: [],
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData 获取公共素材库数据]
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'queryCategorysByParentId',
                ParentId: '0',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
                isAll: true,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
            });
        }

        /**
         * [newCategory 新建公共素材库]
         * @return {[type]} [description]
         */
        $scope.newCategory = function() {
            getAllType().then(function(data) {
                var params = {
                    SHARECATEGORYID: 0,
                    // MODALID: 38,
                    CORDER: -1,
                    zuiqian: data,
                    isSecondClassify: false,
                };
                newAndEditCategory(params, '新建');
            });
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.items.length === $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (let i = 0; i < $scope.data.items.length; i++) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            }
        };

        /**
         * [delete 删除公共素材库]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.delete = function(item) {
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'deleteCategory',
                CategoryIds: !!item ? item.SHARECATEGORYID : trsspliceString.spliceString($scope.data.selectedArray, 'SHARECATEGORYID', ',')
            };
            modalDialog.confirmModal('删除', '是否确定删除所选公共素材库？', function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS === 'true') {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            $scope.data.selectedArray = [];
                            requestData();
                        });
                    }
                });
            });
        };

        /**
         * [modify 修改]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.modify = function(item) {
            getAllType().then(function(data) {
                item.zuiqian = data;
                item.isSecondClassify = false;
                newAndEditCategory(item, '修改');
            });
        };

        /**
         * [getAllType 获取所有类型]
         * @return {[type]} [description]
         */
        function getAllType() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'queryCategorysByParentId',
                ParentId: '0',
                CURRPAGE: 1,
                PAGESIZE: $scope.page.PAGESIZE,
                isAll: true,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data.DATA);
            });
            return defer.promise;
        }

        /**
         * [newAndEditCategory 新建修改公共素材库]
         * @param  {[type]} edit [description]
         * @return {[type]}      [description]
         */
        function newAndEditCategory(item, type) {
            publicLibraryCategoryService.newPublicLibraryCategory(item).then(function(result) {
                var params = {
                    serviceid: 'mlf_sharedmaterial',
                    methodname: 'saveCategory',
                    CategoryId: result.SHARECATEGORYID,
                    CategoryName: result.CATEGORYNAME,
                    Status: result.STATUS,
                    ParentId: !!item.ParentId ? item.ParentId : 0,
                    // ModalId: 38,
                    Corder: result.CORDER,
                    VisibleCategorys: result.VISIBLECATEGORYS,
                    ISMEIZIDEFAULTPATH: result.ISMEIZIDEFAULTPATH,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (!!data && data.ISSUCCESS === 'true') {
                        modalDialog.alertType(type + '公共素材库类别成功', '', 'success', false, function() {
                            requestData();
                        });
                    }
                });
            });
        }

        /**
         * [goCategoryMgr description] 跳转到稿件类别管理页面
         * @return {[type]} [description]
         */
        $scope.goCategoryMgr = function(item) {
            $scope.$parent.titleName = item.CATEGORYNAME + ' >> 公共素材库类别管理';
            $state.go('manageconfig.sysmanage.publicmateriallibrary.categorylibrary', {
                sharecategoryid: item.SHARECATEGORYID,
                categoryname: item.CATEGORYNAME
            });
        };

        /**
         * [pageChanged 页码切换]
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [jumpToPage 跳转到-分页]
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.page.copyCurrPage > $scope.page.PAGECOUNT) $scope.page.copyCurrPage = $scope.page.PAGECOUNT;
            if ($scope.page.copyCurrPage < 0) $scope.page.copyCurrPage = 1;
            $scope.page.CURRPAGE = $scope.page.copyCurrPage;
            requestData();
        };

        /**
         * [selectPageNum 修改分页数量]
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.page.CURRPAGE = 1;
            requestData();
        };
    }]);